import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Form, Input } from 'antd';

export function Greater(): JSX.Element {
	return (
		<Col span={12}>
			<Form.Item name="min_rpn" label={I18n.get('Minimum')} labelCol={{ span: 24 }}>
				<Input placeholder={I18n.get('Minimum')} />
			</Form.Item>
		</Col>
	);
}
